(function () {
  'use strict';

  if (window.rwProductCardReviewsInitialized) return;
  window.rwProductCardReviewsInitialized = true;

  var judgeResourcesPromise;

  function loadScript(url, readyCheck) {
    if (readyCheck()) return Promise.resolve();

    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.dataset.rwJudgeResource = url;
      script.onload = function () {
        if (readyCheck()) {
          resolve();
        } else {
          reject(new Error('Judge.me resource loaded without the expected API.'));
        }
      };
      script.onerror = function () {
        reject(new Error('Judge.me resource could not be loaded.'));
      };
      document.head.appendChild(script);
    });
  }

  function loadRawScript(url) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.dataset.rwJudgeResource = url;
      script.onload = resolve;
      script.onerror = function () {
        reject(new Error('Judge.me resource could not be loaded.'));
      };
      document.head.appendChild(script);
    });
  }

  function loadJudgeResources() {
    if (window.jdgm && window.jdgm._WriteReviewModal) {
      return Promise.resolve(window.jdgm);
    }

    if (judgeResourcesPromise) return judgeResourcesPromise;

    judgeResourcesPromise = new Promise(function (resolve, reject) {
      var attempts = 0;

      function waitForJudgeCore() {
        attempts += 1;
        if (window.jdgm && window.jdgm.CDN_HOST) {
          var jdgm = window.jdgm;
          var host = jdgm.CDN_HOST;

          if (typeof jdgm.loadCSS === 'function' && typeof jdgm.widgetPath === 'function') {
            jdgm.loadCSS(jdgm.widgetPath('form.css'));
          }

          Promise.resolve()
            .then(function () {
              return loadScript(host + 'widget/base.js', function () {
                return Boolean(window.jdgm && window.jdgm.$);
              });
            })
            .then(function () {
              return loadScript(host + 'widget/common.js', function () {
                return Boolean(window.jdgm && typeof window.jdgm.shopParams === 'function');
              });
            })
            .then(function () {
              return loadRawScript(host + 'widget/form.js');
            })
            .then(function () {
              return loadScript(host + 'widget/write_review_modal.js', function () {
                return Boolean(window.jdgm && window.jdgm._WriteReviewModal);
              });
            })
            .then(function () {
              resolve(window.jdgm);
            })
            .catch(reject);
          return;
        }

        if (attempts >= 50) {
          reject(new Error('Judge.me is not available.'));
          return;
        }
        window.setTimeout(waitForJudgeCore, 100);
      }

      waitForJudgeCore();
    }).catch(function (error) {
      judgeResourcesPromise = null;
      throw error;
    });

    return judgeResourcesPromise;
  }

  function createProductContext(card) {
    var context = document.createElement('div');
    var title = card.dataset.productTitle || '';
    var imageUrl = card.dataset.productImage || '';

    context.className = 'jdgm-widget jdgm-review-widget';
    context.dataset.productTitle = title;
    context.dataset.productId = card.dataset.productId || '';
    context.style.display = 'none';
    var widgetContent = document.createElement('div');
    widgetContent.className = 'jdgm-rev-widg';
    widgetContent.dataset.productTitle = title;
    widgetContent.dataset.imageUrl = imageUrl;
    context.appendChild(widgetContent);
    document.body.insertBefore(context, document.body.firstChild);
    return context;
  }

  function openReviewModal(trigger) {
    var card = trigger.closest('[data-rw-product-card]');
    if (!card || trigger.dataset.rwReviewLoading === 'true') return;

    trigger.dataset.rwReviewLoading = 'true';
    trigger.setAttribute('aria-busy', 'true');

    loadJudgeResources()
      .then(function (jdgm) {
        window.jdgmSettings = window.jdgmSettings || {};
        window.jdgmSettings.rating_only_reviews_enabled = true;

        var context = createProductContext(card);
        var modal = new jdgm._WriteReviewModal(jdgm.$);
        var productId = parseInt(card.dataset.productId || '0', 10);

        return modal
          .setup('jdgm-review-widget-modal', productId)
          .then(function (isReady) {
            context.remove();
            if (!isReady) throw new Error('Judge.me review modal could not be initialized.');
            modal.showModalPage();
          })
          .catch(function (error) {
            context.remove();
            throw error;
          });
      })
      .catch(function (error) {
        console.error('[RW Product Reviews]', error);
        var isArabic = document.documentElement.lang.toLowerCase().indexOf('ar') === 0;
        window.alert(
          isArabic
            ? 'تعذر فتح نموذج المراجعة الآن. يرجى المحاولة مرة أخرى.'
            : 'The review form could not be opened. Please try again.'
        );
      })
      .finally(function () {
        delete trigger.dataset.rwReviewLoading;
        trigger.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rw-review-trigger]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openReviewModal(trigger);
  });
})();
